import { render, staticRenderFns } from "./DilemmaProjectItem.vue?vue&type=template&id=0a76e926&scoped=true"
import script from "./DilemmaProjectItem.vue?vue&type=script&lang=ts"
export * from "./DilemmaProjectItem.vue?vue&type=script&lang=ts"
import style0 from "./DilemmaProjectItem.vue?vue&type=style&index=0&id=0a76e926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a76e926",
  null
  
)

export default component.exports